/* drehmer-package-cart.js (PDP v11, framed-bundle template only)
   Framed, gallery wrap or custom size: Add to Cart puts ONE line in the cart. The line is a hidden
   "package" product built by the bundler service (painting + frame as a fixed Shopify bundle, with a
   picture of the framed painting). Unframed standard sizes never reach this file's code path.

   Reads the selection through window.drehmerPackageState() (defined in main-product-bundle.liquid, 3c).
   Any failure (no service URL, network error, 10 s timeout, price mismatch, cart error) falls back to
   the old flow: product-form.js adds painting + frame as two lines. Add to Cart never breaks. */
(function () {
  'use strict';
  if (window.__drehmerPackageCart) return;
  window.__drehmerPackageCart = true;

  /* Service base URL. window.DREHMER_PACKAGE_URL overrides it (tests). Empty = old flow. */
  var SERVICE_URL = 'https://pdp-bundler-production.up.railway.app';
  var CLICK_TIMEOUT_MS = 10000;
  var PREWARM_TIMEOUT_MS = 30000;
  var PREWARM_DEBOUNCE_MS = 650;
  var PREWARM_CUSTOM_QUIET_MS = 1500;
  var SLOW_COPY_MS = 3000;

  var log = window.__drehmerPackageLog = [];
  function note(ev, data) {
    var e = { t: Date.now(), ev: ev };
    if (data) e.data = data;
    log.push(e);
    if (log.length > 60) log.shift();
  }

  function serviceUrl() {
    var u = (typeof window.DREHMER_PACKAGE_URL === 'string') ? window.DREHMER_PACKAGE_URL : SERVICE_URL;
    return String(u || '').replace(/\/+$/, '');
  }
  function readState() {
    try { return typeof window.drehmerPackageState === 'function' ? window.drehmerPackageState() : null; }
    catch (e) { return null; }
  }
  /* package only for a frame, a gallery wrap or a custom size; never in "request this size" mode */
  function needsPackage(s) {
    if (!s || s.request || !s.productId) return false;
    if (s.custom) return !!(s.custom.w_in > 0 && s.custom.h_in > 0);
    return (s.format === 'framed' || s.format === 'stretched') && !!s.frameVariantId && !!s.variantId;
  }
  function payloadOf(s, prewarm) {
    var p = {
      product_id: Number(s.productId),
      variant_id: s.custom ? null : Number(s.variantId),
      frame_variant_id: (s.format === 'framed' || s.format === 'stretched') && s.frameVariantId ? Number(s.frameVariantId) : null,
      custom: s.custom ? { w_in: s.custom.w_in, h_in: s.custom.h_in } : null,
      prewarm: !!prewarm
    };
    /* Catalog frame: the variant is only the price source (same price for every style in a band);
       the style travels as its slug. Never on Gallery Wrap. */
    if (s.format === 'framed' && s.frame && s.frame.slug) p.frame_style = s.frame.slug;
    return p;
  }
  function keyOf(p) {
    return [p.product_id, p.variant_id || 'c', p.frame_variant_id || 'u', p.custom ? (p.custom.w_in + 'x' + p.custom.h_in) : '', p.frame_style || ''].join('|');
  }

  /* ---------- service calls (one in flight per selection; the click reuses the prewarm) ---------- */
  var cache = {};
  function callService(p, timeoutMs) {
    var url = serviceUrl();
    if (!url) return Promise.reject(new Error('no service url'));
    var ctrl = (typeof AbortController === 'function') ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, timeoutMs);
    return fetch(url + '/bundle', {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(p),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) {
      if (!r.ok) throw new Error('bundle http ' + r.status);
      return r.json();
    }).then(function (d) {
      clearTimeout(timer);
      return d;
    }, function (e) {
      clearTimeout(timer);
      throw e;
    });
  }
  function usable(d) { return !!(d && d.variant_id && d.price != null); }
  function ensurePackage(p, timeoutMs) {
    var k = keyOf(p);
    var c = cache[k];
    if (c && c.result) return Promise.resolve(c.result);
    if (c && c.promise) return c.promise;
    var pr = callService(p, timeoutMs).then(function (d) {
      if (usable(d)) cache[k] = { result: d };
      else delete cache[k];
      return d;
    }, function (e) {
      delete cache[k];
      throw e;
    });
    cache[k] = { promise: pr };
    return pr;
  }
  function withTimeout(promise, ms) {
    return new Promise(function (resolve, reject) {
      var t = setTimeout(function () { reject(new Error('timeout')); }, ms);
      promise.then(function (v) { clearTimeout(t); resolve(v); }, function (e) { clearTimeout(t); reject(e); });
    });
  }

  /* ---------- prewarm: the package exists before the click ---------- */
  var prewarmTimer = null, lastPrewarmKey = '', lastChangeAt = 0;
  function schedulePrewarm(delay) {
    clearTimeout(prewarmTimer);
    prewarmTimer = setTimeout(function () {
      var s = readState();
      if (!needsPackage(s) || !serviceUrl()) return;
      /* a custom size is typed: wait for a longer pause, so half-typed sizes never become packages */
      var quiet = Date.now() - lastChangeAt;
      if (s.custom && quiet < PREWARM_CUSTOM_QUIET_MS) { schedulePrewarm(PREWARM_CUSTOM_QUIET_MS - quiet); return; }
      var p = payloadOf(s, true);
      var k = keyOf(p);
      if (k === lastPrewarmKey && cache[k]) return;
      lastPrewarmKey = k;
      note('prewarm', k);
      ensurePackage(p, PREWARM_TIMEOUT_MS).then(function (d) {
        note('prewarm-ok', { k: k, v: d && d.variant_id, created: d && d.created });
      }, function (e) {
        note('prewarm-fail', { k: k, err: String(e && e.message || e) });
        if (lastPrewarmKey === k) lastPrewarmKey = '';
      });
    }, delay || PREWARM_DEBOUNCE_MS);
  }
  ['click', 'change', 'input'].forEach(function (type) {
    document.addEventListener(type, function (ev) {
      var t = ev.target;
      if (!t || !t.closest || !t.closest('.drehmer')) return;
      /* the add buttons themselves are not a change of selection */
      if (t.closest('product-form, [data-drehmer-sticky], .floating-checkout')) return;
      lastChangeAt = Date.now();
      schedulePrewarm();
    }, { passive: true });
  });

  /* ---------- button state: short, calm copy while the package is prepared ---------- */
  (function injectStyle() {
    if (document.getElementById('drehmer-pkg-style')) return;
    var st = document.createElement('style');
    st.id = 'drehmer-pkg-style';
    st.textContent =
      '.drehmer__pkg-note{display:none}' +
      '.drehmer__add-btn.drehmer-pkg-busy{opacity:1!important;cursor:progress}' +
      '.drehmer__add-btn.drehmer-pkg-busy [data-drehmer-btn-normal],.drehmer__add-btn.drehmer-pkg-busy [data-drehmer-btn-enter]{display:none!important}' +
      '.drehmer-pkg-busy .loading-overlay__spinner{display:none!important}' +
      '.drehmer__add-btn.drehmer-pkg-busy .drehmer__pkg-note{display:inline;animation:drehmer-pkg-breathe 1.8s ease-in-out infinite}' +
      '.drehmer__sticky-btn.drehmer-pkg-busy{opacity:1!important;cursor:progress}' +
      '.drehmer__sticky-btn.drehmer-pkg-busy .drehmer__pkg-note{display:flex;position:absolute;inset:0;align-items:center;justify-content:center;animation:drehmer-pkg-breathe 1.8s ease-in-out infinite}' +
      '@keyframes drehmer-pkg-breathe{0%,100%{opacity:1}50%{opacity:.62}}' +
      '@media (prefers-reduced-motion:reduce){.drehmer-pkg-busy .drehmer__pkg-note{animation:none!important}}';
    (document.head || document.documentElement).appendChild(st);
  })();
  function buttons() {
    return {
      main: document.querySelector('[data-drehmer-add-btn]'),
      sticky: document.querySelector('[data-drehmer-sticky-add]')
    };
  }
  function noteEl(btn) {
    var n = btn.querySelector('.drehmer__pkg-note');
    if (!n) {
      n = document.createElement('span');
      n.className = 'drehmer__pkg-note';
      n.setAttribute('aria-hidden', 'true');
      btn.appendChild(n);
    }
    return n;
  }
  var slowTimer = null;
  function setBusy(on) {
    var b = buttons();
    clearTimeout(slowTimer);
    [b.main, b.sticky].forEach(function (btn) {
      if (!btn) return;
      if (on) noteEl(btn).textContent = 'Adding to cart…';
      btn.classList.toggle('drehmer-pkg-busy', on);
      if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy');
    });
    /* .loading on the main button: the section mirrors it onto the sticky bar and the mobile
       floating bar, and its CSS turns off pointer events (no second click) */
    if (b.main) b.main.classList.toggle('loading', on);
    if (on) {
      slowTimer = setTimeout(function () {
        [b.main, b.sticky].forEach(function (btn) { if (btn) noteEl(btn).textContent = 'Almost ready…'; });
      }, SLOW_COPY_MS);
    }
  }

  /* ---------- the add ---------- */
  /* What the customer reads is the site name the card showed ("Classic Ornate"); the service's
     frame_label is the same name from the same catalog. The supplier code ("Frame 7 · Grace") only
     goes in the hidden _frame_code. Old Shopify-variant cards keep their own name. */
  function frameText(s, d) {
    if (s.frame && s.frame.site) return s.frame.site;
    if (d && typeof d.frame_label === 'string' && d.frame_label) return d.frame_label;
    return s.frameName || 'Custom frame';
  }
  function frameCode(s, d) {
    if (s.frame && s.frame.code) return s.frame.code;
    var m = String((d && (d.frame_code || d.frame_style)) || '').match(/Frame\s+\d+(\s*\u00b7\s*[^\u2014]+?)?(?=\s*\u2014|$)/);
    return m ? m[0].trim() : '';
  }
  function lineProperties(s, d, k) {
    var props = {};
    if (s.custom) props['Custom size'] = s.sizeText;
    else props['Painting size'] = s.sizeText;
    if (s.format === 'framed') {
      props['Frame'] = frameText(s, d);
      props['Made to fit'] = s.fitText;
      if (s.frame) props['_frame_code'] = frameCode(s, d);
    } else if (s.format === 'stretched') {
      props['Frame'] = 'Gallery wrap';
      props['Made to fit'] = s.fitText;
    }
    props['_package_key'] = String((d && (d.key || d.package_key)) || k);
    if (s.productUrl) props['_product'] = s.productUrl;
    /* the cart drawer treats any line whose properties contain "ID" as the old two-line bundle */
    Object.keys(props).forEach(function (name) {
      if (props[name] == null || props[name] === '') { delete props[name]; return; }
      props[name] = String(props[name]).replace(/ID/g, 'Id');
    });
    return props;
  }
  function cartAdd(pf, d, s, k) {
    var cart = pf.cart || document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var fd = new FormData();
    fd.append('id', String(d.variant_id));
    fd.append('quantity', String(s.quantity || 1));
    var props = lineProperties(s, d, k);
    Object.keys(props).forEach(function (name) { fd.append('properties[' + name + ']', props[name]); });
    if (cart && typeof cart.getSectionsToRender === 'function') {
      fd.append('sections', cart.getSectionsToRender().map(function (x) { return x.id; }));
      fd.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    var config = (typeof fetchConfig === 'function') ? fetchConfig('javascript') : { method: 'POST', headers: { 'Accept': 'application/javascript' } };
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = fd;
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return fetch(addUrl, config).then(function (r) { return r.json(); }).then(function (res) {
      if (!res || res.status) throw new Error('cart add ' + (res && (res.description || res.message) || 'error'));
      return { res: res, cart: cart };
    });
  }
  /* same steps product-form.js runs after a normal add */
  function showCart(pf, out, variantId) {
    var cart = out.cart, res = out.res;
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: variantId });
      }
    } catch (e) {}
    if (!cart) { window.location = (window.routes && window.routes.cart_url) || '/cart'; return; }
    try {
      var quickAddModal = pf.closest('quick-add-modal');
      if (quickAddModal) {
        document.body.addEventListener('modalClosed', function () { setTimeout(function () { cart.renderContents(res); }); }, { once: true });
        quickAddModal.hide(true);
      } else {
        cart.renderContents(res);
      }
    } catch (e) { note('render-fail', String(e && e.message || e)); }
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
    if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
  }

  /* v14: a custom size whose price has no helper variant can only be carted as a package. If the service fails,
     the two-line flow would add the form's stale variant, so the shopper gets a short note by the button instead. */
  function cartNote(s) {
    var wrap = document.querySelector('.drehmer .drehmer__add-btn-wrap');
    if (!wrap) return;
    var n = document.querySelector('[data-drehmer-cart-note]');
    if (!n) {
      n = document.createElement('p');
      n.className = 'drehmer-bundle__cart-note';
      n.setAttribute('data-drehmer-cart-note', '');
      n.setAttribute('role', 'alert');
      n.style.cssText = 'margin:10px 0 0;font-size:13px;line-height:1.45;color:#b42318;text-align:center';
      wrap.parentNode.insertBefore(n, wrap.nextSibling);
    }
    n.innerHTML = 'We couldn’t add this size just now. Please try again in a moment' +
      (s && s.requestUrl ? ', or <a href="' + s.requestUrl + '" style="color:inherit;text-decoration:underline">send us the size</a> and we’ll reply by email.' : '.');
  }
  document.addEventListener('input', function (ev) {
    var n = document.querySelector('[data-drehmer-cart-note]');
    if (n && ev.target && ev.target.closest && ev.target.closest('.drehmer')) n.remove();
  }, true);

  var busy = false, bypass = false;
  function fallback(form, reason) {
    note('fallback', reason);
    busy = false;
    setBusy(false);
    var s = readState();
    if (s && s.custom && !s.variantId) {
      note('no-fallback', 'custom size without helper variant');
      cartNote(s);
      return;
    }
    bypass = true;
    try {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    } finally {
      bypass = false;
    }
  }
  function priceCents(d) { return Math.round(parseFloat(String(d.price).replace(/[^0-9.]/g, '')) * 100); }

  /* The click always confirms with a normal (non-prewarm) call: it answers in ~0.5 s when the package
     exists and, for a new one, waits until its picture is ready (the service locks per selection, so it
     queues behind a prewarm still running). If that runs out of time, a package the prewarm already
     returned is still one line; with nothing at all, the old two-line flow takes over. */
  function packageForClick(p) {
    var k = keyOf(p);
    return withTimeout(callService(p, CLICK_TIMEOUT_MS), CLICK_TIMEOUT_MS).then(function (d) {
      if (!usable(d)) throw new Error('bad response');
      cache[k] = { result: d };
      return d;
    }, function (e) {
      var c = cache[k];
      if (c && c.result && usable(c.result)) {
        note('use-prewarm', String(e && e.message || e));
        return c.result;
      }
      throw e;
    });
  }

  function run(pf, form, s) {
    var old = document.querySelector('[data-drehmer-cart-note]');
    if (old) old.remove();
    busy = true;
    setBusy(true);
    var p = payloadOf(s, false);
    var k = keyOf(p);
    note('click', k);
    packageForClick(p).then(function (d) {
      if (!usable(d)) throw new Error('bad response');
      var cents = priceCents(d);
      if (s.totalCents > 0 && Math.abs(cents - s.totalCents) > 1) {
        delete cache[k];
        throw new Error('price mismatch ' + cents + ' vs ' + s.totalCents);
      }
      return cartAdd(pf, d, s, k).then(function (out) {
        note('added', { v: d.variant_id, price: d.price });
        busy = false;
        setBusy(false);
        showCart(pf, out, d.variant_id);
      }, function (e) {
        delete cache[k];
        throw e;
      });
    }).catch(function (e) {
      fallback(form, String(e && e.message || e));
    });
  }

  /* capture phase on document: runs before product-form.js's submit handler on the form */
  document.addEventListener('submit', function (ev) {
    if (bypass) return;
    var form = ev.target;
    if (!form || !form.closest) return;
    var pf = form.closest('product-form');
    if (!pf || !pf.closest('.drehmer')) return;
    var btn = pf.querySelector('[type="submit"]');
    if (busy || (btn && btn.getAttribute('aria-disabled') === 'true')) {
      /* a second click while an add is in flight: swallow it */
      if (busy) { ev.preventDefault(); ev.stopPropagation(); }
      return;
    }
    var s = readState();
    if (!needsPackage(s)) return;
    if (!serviceUrl()) { note('skip', 'no service url'); return; }
    ev.preventDefault();
    ev.stopPropagation();
    run(pf, form, s);
  }, true);
})();
